import React, { useState } from 'react';
import './App.css';
import { linearRegression } from './LinearRegression';
import Plot from 'react-plotly.js';

function App() {
  const [x, setX] = useState('');
  const [y, setY] = useState('');
  const [result, setResult] = useState('');
  const [plotData, setPlotData] = useState({});

  const handleSubmit = (event) => {
    event.preventDefault();
    const xArr = x.split(',').map(Number);
    const yArr = y.split(',').map(Number);
    const result = linearRegression(xArr, yArr);
    setResult(`y = ${result.m}x + ${result.b}`);
    const plotX = [];
    const plotY = [];
    for (let i = 0; i < xArr.length; i++) {
      plotX.push(xArr[i]);
      plotY.push(result.m * xArr[i] + result.b);
    }
    setPlotData({
      data: [
        {
          x: plotX,
          y: plotY,
          type: 'scatter',
          name: 'Linear Regression',
        },
        {
          x: xArr,
          y: yArr,
          type: 'scatter',
          name: 'Input Data',
        },
      ],
      layout: {
        title: `Linear Regression of y = ${result.m}x + ${result.b}`,
      },
    });
  };

  return (
    <div className="App">
      <h1>Linear Regression Calculator</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            Enter x values (comma separated):
            <input type="text" value={x} onChange={(event) => setX(event.target.value)} />
          </label>
        </div>
        <div>
          <label>
            Enter y values (comma separated):
            <input type="text" value={y} onChange={(event) => setY(event.target.value)} />
          </label>
        </div>
        <button type="submit">Calculate</button>
      </form>
      {result && <p>{result}</p>}
      {Object.keys(plotData).length !== 0 && <Plot data={plotData.data} layout={plotData.layout} />}
    </div>
  );
}

export default App;
